import React from 'react';
export function BonusPackage() {
  return <div className="mx-auto mt-12 max-w-2xl rounded-2xl border border-gold/40 bg-gold/10 px-5 py-4 text-center" data-id="element-50" data-mp="358l1wm6272ih">
      <p className="font-display text-lg font-bold uppercase leading-snug text-fog sm:text-xl" data-id="element-51" data-mp="11uc49pr5l10t">
        💰 Total Bonus Value: <span className="text-fog/50 line-through" data-id="element-52" data-mp="1bqf4ur6cwrln">$120</span>{' '}
        <span className="text-gold" data-id="element-53" data-mp="1brzwo91adwft">Today free with the 5 in 1 combo</span>
      </p>
    </div>;
}